/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiCurrencyFromJSON, ApiCurrencyToJSON, } from './ApiCurrency';
import { ApiPlatformFromJSON, ApiPlatformToJSON, } from './ApiPlatform';
import { ApiProjectMerchantFromJSON, ApiProjectMerchantToJSON, } from './ApiProjectMerchant';
import { ApiStatusFromJSON, ApiStatusToJSON, } from './ApiStatus';
export function ApiProjectSimplifiedFromJSON(json) {
    return ApiProjectSimplifiedFromJSONTyped(json, false);
}
export function ApiProjectSimplifiedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'authId': !exists(json, 'authId') ? undefined : json['authId'],
        'cleanedAt': !exists(json, 'cleanedAt') ? undefined : (new Date(json['cleanedAt'])),
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'currency': !exists(json, 'currency') ? undefined : ApiCurrencyFromJSON(json['currency']),
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (new Date(json['deletedAt'])),
        'generatedAt': !exists(json, 'generatedAt') ? undefined : (new Date(json['generatedAt'])),
        'homepageScreenId': !exists(json, 'homepageScreenId') ? undefined : json['homepageScreenId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'ip': !exists(json, 'ip') ? undefined : json['ip'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'lastSync': !exists(json, 'lastSync') ? undefined : (new Date(json['lastSync'])),
        'merchant': !exists(json, 'merchant') ? undefined : ApiProjectMerchantFromJSON(json['merchant']),
        'metaEpMatchQuality': !exists(json, 'metaEpMatchQuality') ? undefined : json['metaEpMatchQuality'],
        'metaEsMatchQuality': !exists(json, 'metaEsMatchQuality') ? undefined : json['metaEsMatchQuality'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'overview': !exists(json, 'overview') ? undefined : json['overview'],
        'platform': !exists(json, 'platform') ? undefined : ApiPlatformFromJSON(json['platform']),
        'signupId': !exists(json, 'signupId') ? undefined : json['signupId'],
        'status': !exists(json, 'status') ? undefined : ApiStatusFromJSON(json['status']),
        'syncEveryHours': !exists(json, 'syncEveryHours') ? undefined : json['syncEveryHours'],
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
        'toClean': !exists(json, 'toClean') ? undefined : json['toClean'],
        'trialEndsAt': !exists(json, 'trialEndsAt') ? undefined : (new Date(json['trialEndsAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiProjectSimplifiedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'authId': value.authId,
        'cleanedAt': value.cleanedAt === undefined ? undefined : (value.cleanedAt.toISOString()),
        'clientId': value.clientId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'currency': ApiCurrencyToJSON(value.currency),
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'generatedAt': value.generatedAt === undefined ? undefined : (value.generatedAt.toISOString()),
        'homepageScreenId': value.homepageScreenId,
        'id': value.id,
        'ip': value.ip,
        'key': value.key,
        'lastSync': value.lastSync === undefined ? undefined : (value.lastSync.toISOString()),
        'merchant': ApiProjectMerchantToJSON(value.merchant),
        'metaEpMatchQuality': value.metaEpMatchQuality,
        'metaEsMatchQuality': value.metaEsMatchQuality,
        'name': value.name,
        'overview': value.overview,
        'platform': ApiPlatformToJSON(value.platform),
        'signupId': value.signupId,
        'status': ApiStatusToJSON(value.status),
        'syncEveryHours': value.syncEveryHours,
        'timezone': value.timezone,
        'toClean': value.toClean,
        'trialEndsAt': value.trialEndsAt === undefined ? undefined : (value.trialEndsAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
